<template>
  <ul class="footer">
    <li class="foot-list" v-for="item in dataList">
      <template v-if="item.type ===0">
        <a @click="openUrl(item)">
          <span class="title">{{ item.title }}：</span>
          <span class="content">{{ item.content }}</span>
        </a>
      </template>
      <template v-if="item.type ===1" @click="openUrl(item)">
        <a @click="openUrl(item)">
          <img :src="item.image" class="footer-img">
        </a>
      </template>
    </li>
    <li class="foot-list">
      <img class="foot-list"/>
    </li>
    <li class="support">技术支持：六盘水司南科技</li>
  </ul>
</template>
<script>
import {CustomOpenApis as api} from "@/api/CustomApis";

export default {
  name: "F-PageHeader",
  data() {
    return {
      dataList: [],
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    loadData() {
      this.$http.get(api.getSettingsList).then(result => {
        if (result.status === 200) {
          result.data.forEach(e => {
            if (e.type === 1) {
              e.sort = 999
            }
          })
          this.dataList = result.data.sort((a, b) => a.sort - b.sort)
        }
      })
    },
    openUrl(e) {
      if (e.url) {
        window.open(e.url, "_blank")
      }
    }
  }
}
</script>

<style scoped lang="less">
@import "~@public/reset.css";
@import "~@public/infoShow.css";

.footer {
  width: 50%;
  text-align: left;
  margin: 0 auto;
}

.foot-list {
  display: inline-block;
  width: 50%;
}

.foot-list a {
  color: #000;
}

.support {
  text-align: center;
}

.footer-img {
  width: 40px;
}
</style>
